import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../common/helpers/helpers";
import HPOTree from "./atoms/HPOTree";
import HPOLegend from "./atoms/HPOTree/HPOLegend";
import ComponentPanel from "./atoms/ComponentPanel/ComponentPanel";
import withErrorGuard from "../HOC/withErrorGuard";
import HelperText from "./atoms/HelperText";

function HPOTreeContainer(props) {
  const { HPOTree: hpoData } = props;
  const { hpo } = hpoData || {};
  const hpoUrl = "http://human-phenotype-ontology.github.io";
  return hpo ? (
    <div className="varsome-result-fixed">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title="Human Phenotype Ontology"
          version={hpoData.version}
          url={getVarsoUrl(hpoUrl)}
          helperPopup={
            <HelperText fieldDescriptionKey="Human Phenotype Ontology" />
          }
          content={
            <div className="varsome-inner-container tw-pb-2">
              <HPOLegend />
              <HPOTree {...props} />
            </div>
          }
        />
      </div>
    </div>
  ) : null;
}

HPOTreeContainer.propTypes = {
  HPOTree: PropTypes.shape({
    hpo: PropTypes.arrayOf(PropTypes.shape({})),
    version: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

HPOTreeContainer.defaultProps = {
  HPOTree: {},
};

export default withErrorGuard(
  HPOTreeContainer,
  "HPO",
  "Human Phenotype Ontology"
);
